import { useNavigate } from 'react-router';
import { Alert, Box, Button, Paper, Stack, Typography } from '@mui/material';
import PageContainer from '../components/PageContainer';
import BlockIcon from '@mui/icons-material/Block';
import { useAppSelector } from '../store/store';
import { logout } from '../api/services';

export default function NoTenantBlock() {
  const navigate = useNavigate();
  const user = useAppSelector((s) => s.auth.user);

  async function handleLogout() {
    await logout();
    navigate('/login', { replace: true });
  }

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'background.default' }}>
      <PageContainer maxWidth="sm" sx={{ py: 3 }}>
        <Paper sx={{ p: { xs: 2, sm: 4 }, textAlign: 'center' }}>
          <BlockIcon color="error" sx={{ fontSize: { xs: 48, sm: 64 }, mb: 2 }} />
          <Typography variant="h5" sx={{ fontWeight: 700, mb: 1, fontSize: { xs: '1.25rem', sm: '1.5rem' } }}>Acceso no disponible</Typography>
          <Alert severity="warning" sx={{ mb: 2, textAlign: 'left' }}>
            {user?.firstName || 'Usuario'} {user?.lastName || ''} no está asignado a ninguna empresa activa.
            Contactá al administrador para que te dé acceso a una empresa del portal.
          </Alert>
          <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="center" spacing={2}>
            <Button onClick={handleLogout} variant="contained" sx={{ width: { xs: '100%', sm: 'auto' } }}>Cerrar sesión</Button>
          </Stack>
        </Paper>
      </PageContainer>
    </Box>
  );
}
